import { isNil } from "lodash-es";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import { ContainerContent } from "@/components/Common/Dashboard/ContainerContent";
import { ContainerTitle } from "@/components/Common/Dashboard/ContainerTitle";

import CardSecondary from "../../UI/Card/CardSecondary";

import CompleteChildWorkflow from "./CompleteChildWorkflow";
import GetNotified from "./GetNotified";
import ProgramDetails from "./ProgramDetails";
import ReleaseOfInformation from "./ReleaseOfInformation";
import ScheduleCall from "./ScheduleCall";
import TeenChildSignup from "./TeenChildSignup";

import "./styles.scss";

export const programDetails = "program-details";
export const consentToTerms = "consent-to-terms";
export const releaseForm = "release-form";
export const signup = "signup";
export const scheduleCall = "schedule-call";
export const getNotified = "get-notified";
export const complete = "complete";

const TeensAndKidsCareProgram = (props) => {
  const [activeStep, setActiveStep] = useState(programDetails);
  const [providerMetaData, setProviderMetaData] = useState(null);
  const [patientMetaData, setPatientMetaData] = useState(null);

  const changeWorkFlowStep = (activeStep, searchParams = null) => {
    window.scrollTo(0, 0);
    setActiveStep(activeStep);

    if (isNil(searchParams)) {
      props.history.push(`/app/teens-and-kids/${activeStep}`);
    } else {
      props.history.push(`/app/teens-and-kids/${activeStep}?${searchParams}`);
    }
  };

  const sharedProps = {
    patientMetaData,
    providerMetaData,
    setPatientMetaData,
    setProviderMetaData,
  };

  const workflowSteps = {
    complete: (
      <CompleteChildWorkflow
        nextStep={() => {
          window.localStorage.removeItem("redirectAfterAuth");
          props.history.push("/app/home");
        }}
        patientMetaData={patientMetaData}
      />
    ),
    "get-notified": <GetNotified {...props} />,
    "program-details": (
      <ProgramDetails
        getNotifiedStep={() => changeWorkFlowStep(getNotified)}
        nextStep={() => changeWorkFlowStep(signup)}
      />
    ),
    "release-form": (
      <ReleaseOfInformation
        nextStep={() => changeWorkFlowStep(scheduleCall, `patientId=${patientMetaData.patient_id}`)}
        patientMetaData={patientMetaData}
        providerMetaData={providerMetaData}
      />
    ),
    "schedule-call": (
      <ScheduleCall
        alreadyScheduled={(patientId) => changeWorkFlowStep(complete, `patientId=${patientId}`)}
        nextStep={() => changeWorkFlowStep(complete, `patientId=${patientMetaData.patient_id}`)}
        patientMetaData={patientMetaData}
      />
    ),
    signup: <TeenChildSignup {...sharedProps} changeWorkFlowStep={changeWorkFlowStep} />,
  };

  const isFirstPageLoad = () => !props.match.params.step;

  const isValidStep = () =>
    props.match.params.step && Object.hasOwn(workflowSteps, props.match.params.step);

  const isValidPath = () => props.match.path && props.match.path.includes("/app/teens-and-kids");

  useEffect(() => {
    (async () => {
      if (isFirstPageLoad() || (isValidPath() && !isValidStep())) {
        props.history.push(`/app/teens-and-kids/${programDetails}`);
      } else if (isValidPath() && isValidStep()) {
        setActiveStep(props.match.params.step);
      } else {
        props.history.push("/app/home");
      }
    })();
  }, [props.match.params.step]);

  return (
    <ContainerContent>
      <ContainerTitle title="Add Child" />

      <CardSecondary className="tw:max-w-[unset]">
        {activeStep && workflowSteps[activeStep]}
      </CardSecondary>
    </ContainerContent>
  );
};

export default withRouter(TeensAndKidsCareProgram);
